import CAJA1040ResponseModel from '@/api/data/CAJ/CAJG1040/CAJA1040ResponseModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAJG1040Service {
  /**
   *
   * @returns string base 64
   */
  public async callAPICAJA1040(): Promise<CAJA1040ResponseModel> {
    const caja1040ResponseModel: CAJA1040ResponseModel = <
      CAJA1040ResponseModel
    > await RestService.post(ApiUrlConstants.CAJA1040, {})
    return caja1040ResponseModel
  }
}
